(() => {
  if (window.pnExactUgc) return;
  window.pnExactUgc = true;
  function init(root = document) {
    root.querySelectorAll('.pn-product ugc-carousel-section').forEach(carousel => {
      if (carousel.dataset.pnExactBound) return;
      carousel.dataset.pnExactBound = 'true';
      const wrapper = carousel.querySelector('.ugc-carousel__track-wrapper');
      const track = carousel.querySelector('.ugc-carousel__track');
      const slides = [...carousel.querySelectorAll('.ugc-carousel__slide')];
      const dots = carousel.querySelector('.ugc-carousel__dots');
      if (!wrapper || !track || !dots) return;
      wrapper.style.overflowX = 'auto'; wrapper.style.scrollSnapType = 'x mandatory';
      wrapper.style.touchAction = 'pan-x pan-y'; track.style.transform = 'none';
      slides.forEach(slide => { slide.style.scrollSnapAlign = 'start'; });
      dots.replaceChildren(...slides.map((slide, i) => {
        const button = document.createElement('button'); button.type = 'button';
        button.className = 'ugc-carousel__dot'; button.setAttribute('aria-label', `Video ${i + 1}`);
        button.addEventListener('click', () => wrapper.scrollTo({left:slide.offsetLeft - slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
        return button;
      }));
      function current() {
        const step = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : 1;
        const index = Math.min(slides.length - 1, Math.round(wrapper.scrollLeft / step));
        [...dots.children].forEach((dot,i) => { dot.classList.toggle('active',i===index); dot.setAttribute('aria-current',String(i===index)); });
      }
      wrapper.addEventListener('scroll', current, {passive:true}); current();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
